/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React, { useEffect, useState } from "react";

import DataGridPica from "../../components/PantallesBKI/DataGridMui/DataGrid";
import { columnsPathXML } from "../../components/PantallesBKI/DataGridMui/Columns/Columns";
import { CustomLoadingOverlay } from "../../components/PantallesBKI/DataGridMui/Loading/Loading";
import { URL_BKI } from "../../constants/URL";

import { TextField, Button, Grid } from "@mui/material";

/*ICONOS*/
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";

/*MENSAJES DE ALERTA*/
import ErrorAlert from "../../components/PantallesBKI/Alertas/ErrorAlert";
import AlertDelete from "../../components/PantallesBKI/Alertas/AlertDelete";
import InsertAlert from "../../components/PantallesBKI/Alertas/InsertAlert";

/* COMPONENTES MUI */
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";

/*  COLORES */
import { colorVerdFosc, colorVermellFosc } from "../../constants/Colors";
import { getAuthToken } from "../../security/tokenUtils";

const APP_JSON = "application/json";
function TablaPathXMLView() {
  const [token] = useState(getAuthToken());

  //Modal
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [selectedRows, setSelectedRows] = useState([]);

  //Estado para escoger accion a realizar en la base de datos
  const [option, setOption] = React.useState([""]);

  const [selectionModel, setSelectionModel] = React.useState([]);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  //variables de catalogo
  const [listTipus, setListTipus] = React.useState([]);

  //Variables de edicion
  const [nsre, setNsre] = React.useState([]);
  const [app, setApp] = React.useState([]);
  const [tramit, setTramit] = React.useState([]);
  const [modalitat, setModalitat] = React.useState([]);
  const [variableOK, setVariableOK] = React.useState([]);
  const [variableKO, setVariableKO] = React.useState([]);
  const [nom, setNom] = React.useState([]);
  const [pathXML, setpathXML] = React.useState([]);
  const [codi, setCodi] = React.useState([]);
  const [tipus, setTipus] = React.useState(undefined);

  //Variables de edición Modal
  const [isEditing, setIsEditing] = useState(false);
  const [botonDesarActivado, setBotonDesarActivado] = useState(false);

  //Funciones para activar o desactivar la edición de los campos

  const handleStopEditing = () => {
    setIsEditing(false);
  };

  /*Control de cambios en los valores de los inputs*/

  const handleChangeApp = (event) => {
    setApp(event.target.value);
  };
  const handleChangeTramit = (event) => {
    setTramit(event.target.value);
  };
  const handleChangeModalitat = (event) => {
    setModalitat(event.target.value);
  };
  const handleChangeVariableOK = (event) => {
    setVariableOK(event.target.value);
    comprobarCampos();
  };
  const handleChangeVariableKO = (event) => {
    setVariableKO(event.target.value);
    comprobarCampos();
  };
  const handleChangeNom = (event) => {
    setNom(event.target.value);
    comprobarCampos();
  };
  const handleChangePathXML = (event) => {
    setpathXML(event.target.value);
    comprobarCampos();
  };
  const handleChangeCodi = (event) => {
    setCodi(event.target.value);
    comprobarCampos();
  };
  const handleChangeTipus = (event) => {
    setTipus(event.target.value);
  };

  useEffect(() => {
    comprobarCampos();
  }, [tipus, app, tramit, modalitat]);

  const comprobarCampos = () => {
    if (app && modalitat && tramit && tipus) {
      setBotonDesarActivado(true);
    } else {
      setBotonDesarActivado(false);
    }
  };

  //Estilos MODAL
  const styleModal = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    maxWidth: "800px",
    maxHeight: "80%",
    overflow: "auto",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
    p: 4,
  };

  function CustomToolbar(props) {
    return (
      <GridToolbarContainer {...props} className="customToolBar">
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <Button
          variant="contained"
          sx={colorVerdFosc}
          startIcon={<EditIcon />}
          size="small"
          onClick={() => accionRow("desar")}
          disabled={selectionModel.length === 0}
          style={{ marginLeft: 16 }}
        >
          Editar
        </Button>
        <Button
          variant="contained"
          type="submit"
          startIcon={<DeleteIcon />}
          onClick={() => AlertDelete(nsre, postData, "eliminar")}
          size="small"
          disabled={selectionModel.length === 0}
          sx={colorVermellFosc}
        >
          Eliminar
        </Button>
        <Button
          variant="contained"
          sx={colorVerdFosc}
          startIcon={<AddCircleIcon />}
          size="small"
          disabled={selectionModel.length === 1}
          onClick={() => accionRow("insertar")}
        >
          NOVA ENTRADA
        </Button>
      </GridToolbarContainer>
    );
  }

  const getData = () => {
    fetch(URL_BKI.PATH_XML, {
      headers: {
        "Content-Type": APP_JSON,
        Authorization: `Bearer ${token}`,
        Accept: APP_JSON,
      },
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        setData(myJson);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(
          `Ha ocurrido un error al pedir el recurso. Error: ${error.message}`
        );
        ErrorAlert("ERROR " + error);
        setIsLoading(false);
      });
  };

  const postData = async (accion) => {
    await fetch(URL_BKI.POST_PATH_XML, {
      method: "post",
      headers: {
        Accept: APP_JSON,
        Authorization: `Bearer ${token}`,
        "Content-Type": APP_JSON,
      },
      body: JSON.stringify({
        NSRE: nsre,
        APLICACIO: app,
        TRAMIT: tramit,
        MODALITAT: modalitat,
        ID_OK: variableOK,
        ID_KO: variableKO,
        NOM: nom,
        PATH_XML: pathXML,
        CODI: codi,
        ACCION: accion,
        TIPUS: tipus,
      }),
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        if (myJson === 1) {
          switch (accion) {
            case "desar":
              InsertAlert("Dades actualitzades correctament");
              break;
            case "eliminar":
              InsertAlert("Dades eliminades correctament");
              break;
            case "insertar":
              InsertAlert("Dades agregades correctament");
              break;
            default:
              ErrorAlert("ERROR");
              break;
          }
          getData();
        } else {
          ErrorAlert("ERROR");
        }
      })
      .catch((error) => {
        ErrorAlert("Error " + error.message);
      });

    setOpen(false);
  };

  function accionRow(action) {
    if (action === "desar") {
      setOption("desar");
    } else if (action === "insertar") {
      //1r Limpiamos los campos
      setNsre("");
      setApp("");
      setTramit("");
      setModalitat("");
      setVariableOK("");
      setVariableKO("");
      setNom("");
      setpathXML("");
      setCodi("");
      setTipus("");
      //2n Pasamos la opcion que queremos hacer
      setOption("insertar");
    } else {
      throw new Error("Unexpected value for action");
    }

    handleOpen(); //abrimos modal
  }

  function mostraForm() {
    const row = selectedRows[0];

    if (selectionModel.length > 0) {
      setNsre(row.NSRE);
      setApp(row.APLICACIO);
      setTramit(row.TRAMIT);
      setModalitat(row.MODALITAT);
      setVariableOK(row.ID_VARIABLE_OK);
      setVariableKO(row.ID_VARIABLE_KO);
      setNom(row.NOM);
      setpathXML(row.PATH_XML);
      setCodi(row.CODI);
      setTipus(row.NODES_TYPE_ID);
      handleStopEditing();
    }
  }

  useEffect(() => {
    mostraForm();
  }, [selectedRows]);

  function getTipus() {
    fetch(URL_BKI.PATH_GET_LIST_TIPUS, {
      headers: {
        "Content-Type": APP_JSON,
        Accept: APP_JSON,
      },
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        setListTipus(myJson);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(
          `Ha ocurrido un error al pedir el recurso. Error: ${error.message}`
        );
        ErrorAlert("ERROR " + error);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    getData();
    getTipus();
  }, []);

  return (
    <div className="w-100, boxPantalla">
      <div>
        <Modal
          sx={{
            width: "70%",
            margin: "150px auto",
          }}
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleModal} className="modal-edicio">
            <Grid container spacing={1}>
              <Grid item xs={5}>
                <TextField
                  id="outlined-basic"
                  name="nsre"
                  label="NSRE"
                  sx={{
                    width: "100%",
                  }}
                  value={nsre ? nsre : "Valor Automàtic"}
                  onChange={handleChangeTramit}
                  variant="outlined"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  id="outlined-basic"
                  name="app"
                  label="APP"
                  required
                  sx={{
                    width: "100%",
                  }}
                  value={app}
                  onChange={handleChangeApp}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  id="outlined-basic"
                  name="tramit"
                  label="TRAMIT"
                  required
                  sx={{
                    width: "100%",
                  }}
                  value={tramit}
                  onChange={handleChangeTramit}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  required
                  id="outlined-basic"
                  name="modalitat"
                  label="MODALITAT"
                  sx={{
                    width: "100%",
                  }}
                  value={modalitat}
                  onChange={handleChangeModalitat}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={3.3}>
                <TextField
                  id="outlined-basic"
                  name="id_ok"
                  label="ID_OK"
                  value={variableOK}
                  multiline
                  sx={{
                    width: "100%",
                  }}
                  onChange={handleChangeVariableOK}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={3.3}>
                <TextField
                  id="outlined-basic"
                  name="id_ko"
                  label="ID_KO"
                  value={variableKO}
                  multiline
                  sx={{
                    width: "100%",
                  }}
                  onChange={handleChangeVariableKO}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={3.2}>
                <TextField
                  id="outlined-basic"
                  name="codi"
                  label="CODI"
                  value={codi}
                  multiline
                  sx={{
                    width: "100%",
                  }}
                  onChange={handleChangeCodi}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={10}>
                <TextField
                  id="outlined-basic"
                  name="nom"
                  label="NOM"
                  sx={{
                    width: "100%",
                  }}
                  value={nom}
                  onChange={handleChangeNom}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={10}>
                <TextField
                  id="outlined-basic"
                  name="PathXML"
                  label="PathXML"
                  value={pathXML}
                  multiline
                  sx={{
                    width: "100%",
                  }}
                  onChange={handleChangePathXML}
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={10}>
                <FormControl
                  sx={{ mt: 4, minWidth: 600, width: "fit-content" }}
                  size="small"
                >
                  <InputLabel id="tipus-select-label" htmlFor="tipus-select">
                    TIPUS *
                  </InputLabel>
                  <Select
                    labelId="tipus-select-label"
                    id="tipus-select"
                    value={tipus}
                    label={"TIPUS *"}
                    onChange={handleChangeTipus}
                  >
                    {listTipus.map((lin) => (
                      <MenuItem value={lin.id} key={lin.id}>
                        {lin.codi}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <div className="btn-edicio">
              <Button
                variant="contained"
                type="submit"
                onClick={() => postData(option)}
                startIcon={<SaveIcon />}
                disabled={!botonDesarActivado}
                sx={colorVerdFosc}
              >
                Desar
              </Button>

              <Button
                variant="contained"
                startIcon={<CancelIcon />}
                onClick={handleClose}
                color="inherit"
              >
                Cancelar
              </Button>
            </div>
          </Box>
        </Modal>
      </div>
      <h2>Taula de nodes XML</h2>
      <DataGridPica
        ampleTaula="90%"
        checkboxSelection={true}
        data={data}
        density="compact"
        rowHeight={90}
        col={columnsPathXML}
        rowId={(row) => row.NSRE}
        components={{
          Toolbar: CustomToolbar,
          LoadingOverlay: CustomLoadingOverlay,
        }}
        selectionModel={selectionModel}
        onSelectionModelChange={(selection) => {
          const selectedIDs = [...new Set(selection)]; //Obtengo el campo CLAU y GRUP seleccionado
          if (selection.length > 1) {
            //Comparo si he seleccionado otro valor anteriormente para hacer el cambio

            const selectionSet = new Set(selectionModel); //obtenemos el valor anterior
            const result = selection.filter((s) => !selectionSet.has(s)); //comprobamos si es diferente el valor seleccionado al anterior, y si es así lo cambiamos
            setSelectionModel(result);
            setSelectedRows(data.filter((row) => result.includes(row.NSRE))); //Filtramos a partir del nuevo campo seleccionado al origen de datos
          } else {
            const getSelectedRows = data.filter((row) =>
              selectedIDs.includes(row.NSRE)
            ); //Busco en el origen de datos a partir del valor seleccionado

            setSelectedRows(getSelectedRows); //Asigno los valores obtenidos
            setSelectionModel(selection); //Guardo la CLAU actual seleccionada
          }
        }}
        loading={isLoading}
      />
    </div>
  );
}
export default TablaPathXMLView;
